import { render, staticRenderFns } from "./forum-comment-like.vue?vue&type=template&id=6b949346&"
import script from "./forum-comment-like.vue?vue&type=script&lang=js&"
export * from "./forum-comment-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports